import React from 'react';
import { Typography } from '../../components';
import { Link } from 'react-router';

interface StatSectionProps {
  title: string;
  linkText: string;
  linkTo: string;
  children: React.ReactNode;
}

export function StatSection({ title, linkText, linkTo, children }: StatSectionProps) {
  return (
    <div>
      <div className="flex items-center gap-2 md:gap-4 mb-4 min-h-6 md:justify-normal justify-between">
        <Typography variant="h5" className="md:!font-medium md:!text-xl">
          {title}
        </Typography>
        <Link
          to={linkTo}
          className="text-primary text-sm font-normal h-5 px-0 min-w-0 hover:underline"
        >
          {linkText}
        </Link>
      </div>
      <div className="bg-white border border-gray-90 rounded-3.5 flex flex-col shadow-[0_.25rem_1rem_0_rgba(0,0,0,0.03)]">
        <div className="flex flex-col divide-y divide-gray-90">{children}</div>
      </div>
    </div>
  );
}
